
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import api from "@/api";
import { MailSettingsEditDto } from "../../../api/appService";

@Component
export default class Calc extends Vue {
  form: MailSettingsEditDto = {
    defaultFromAddress:undefined,
    defaultFromDisplayName:undefined,
    host:undefined,
    port:undefined,
    userName:undefined,
    password:undefined,
    domain:undefined,
    enableSsl:undefined,
    useDefaultCredentials:undefined,
  };

  created() {
    this.fetchData();
  }

  async fetchData() {
    await api.tenantSetting.getMailSettings().then(res => {
      this.form = res;
    });
  }

  async onSubmit() {
    await api.tenantSetting
      .updateMailSettings({
        body: this.form
      })
      .then(res => {
        this.$message.success("更新成功!");
      });
    await this.fetchData();
  }
  onCancel() {
    this.$message({
      message: "cancel!",
      type: "warning"
    });
  }
}
